import { render, staticRenderFns } from "./TimeSlotsAvailability.vue?vue&type=template&id=179d07e2&"
import script from "./TimeSlotsAvailability.vue?vue&type=script&lang=js&"
export * from "./TimeSlotsAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports